"use client";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Col, Form, Input, Row, Select, Checkbox, Tooltip } from "antd";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";

const CollateralClassification = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    collateralTypeOptions,
    exposureTypeOptions,
    loanCollateralOptions,
    valuationMethodOptions,
  } = props;

  return (
    <div>
      <h1
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          margin: 0,
          marginBottom: "24px",
        }}
      >
        Collateral Classification
      </h1>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Collateral Type
                  <Tooltip title="Select the collateral type">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="collateralType"
              rules={[
                {
                  required: true,
                  message: "Please select collateral type",
                },
              ]}
            >
              <Select
                placeholder="Select collateral type"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={collateralTypeOptions}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Exposure Type
                  <Tooltip title="Select the exposure type">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="exposureType"
              rules={[
                {
                  required: true,
                  message: "Please select exposure type",
                },
              ]}
            >
              <Select
                placeholder="Select exposure type"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={exposureTypeOptions}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CollateralClassification;
